import React, { useState } from "react";
import {
  Box,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InfoDialog from "../infoDialog/InfoDialog";

const InfoTextFieldWithDialog = ({
  label,
  value,
  onChange,
  infoTitle,
  infoDescription,
  ...props
}) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          mb: 2,
          minHeight: "2.5rem", // force a minimum height for consistent alignment
        }}
      >
        <TextField
          label={label}
          value={value}
          onChange={onChange}
          fullWidth
          variant="standard"
          margin="dense"
          {...props}
        />
        <IconButton
          onClick={handleClickOpen}
          edge="end"
          size="small"
          sx={{ ml: 1, alignSelf: "center" }}
        >
          <InfoOutlinedIcon fontSize="small" color="action" />
        </IconButton>
      </Box>
      <InfoDialog
        open={open}
        onClose={handleClose}
        title={infoTitle}
        content={infoDescription}
      />
    </>
  );
};

export default InfoTextFieldWithDialog;
